/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * User-selectable caption font-family stacks.
 */
export enum ClosedCaptionFontFamily {
  Default = "Arial, sans-serif",
  SansSerif = "Arial, Helvetica, sans-serif",
  Serif = "'Times New Roman', Times, serif",
  Monospace = "'Courier New', Courier, monospace",
  Casual = "'Comic Sans MS', cursive"
}
